import { NetcheckScreen } from "../../features/netcheck";

/** FS-C1-08 학교망 진단(SR-NET-05) — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/netcheck */
export default function NetcheckPage() {
  return <NetcheckScreen />;
}
